/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：384
 */

module.exports = {
  container: "WatchItemDetail_container__1INMW",
  header: "WatchItemDetail_header__3c0UR",
  flexSc: "WatchItemDetail_flexSc__3U322",
  wrapper: "WatchItemDetail_wrapper__ywWVz",
  name: "WatchItemDetail_name__3AEup",
  title: "WatchItemDetail_title__3QN41",
  screenIcon: "WatchItemDetail_screenIcon__6MeGU",
  closeAction: "WatchItemDetail_closeAction__Wocy4",
  resetAction: "WatchItemDetail_resetAction__UWrFc",
  action: "WatchItemDetail_action__2X-T3",
  unFoldAction: "WatchItemDetail_unFoldAction__2NGlI",
  content: "WatchItemDetail_content__qc7SS",
  line: "WatchItemDetail_line__-tSA9",
  lineKey: "WatchItemDetail_lineKey__1WkCG",
  lineKeyText: "WatchItemDetail_lineKeyText__2IbV-",
  lineValue: "WatchItemDetail_lineValue__2UvXp",
  text: "WatchItemDetail_text__2xQ8V"
}
